// extracted by mini-css-extract-plugin
export default {"SectionsForm__Wrapper":"SectionsForm_SectionsForm__Wrapper__NGrpi","SectionsForm__Label":"SectionsForm_SectionsForm__Label__NQywj"};